// START IMPORTS
// Context imports
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
// Core lib v2 imports
import { Header } from '@ltvco/refresh-lib/v2';
// Vendor imports
import { useEffect } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
  changeSingleReportVariation: (variation: boolean) => void;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({
  handleSearchSuccess,
  changeSingleReportVariation,
}: HeaderParentProps) => {
  // START HOOKS_AND_QUERIES
  const { singleReportVariation } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    changeSingleReportVariation(singleReportVariation);
  }, [singleReportVariation, changeSingleReportVariation]);
  // END EFFECTS

  // START RENDER
  return <Header onSearchSuccess={handleSearchSuccess} />;
  // END RENDER
};
